import { MatDialog, MatSnackBar } from '@angular/material';
import { Component, OnInit } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { ActivatedRoute } from '@angular/router';
import { orderBy } from 'src/app/services/mapping.service';
import { AddCurriculumCourseComponent } from '../add-curriculum-course/add-curriculum-course.component';
import { List } from 'src/app/stores/administrator/list.store';

@Component({
  selector: 'app-curriculum-course',
  templateUrl: './curriculum-course.component.html',
  styleUrls: ['./curriculum-course.component.scss']
})
export class CurriculumCourseComponent implements OnInit {
  CURRICULAR = [];
  SELECTED_CURRICULUM: any = null;
  PROCESS: boolean = false;
  SELECTED_KEY: string = null;
  FUCULTY_KEY: any = null;
  COURSE_TYPES: any[] = [];

  constructor(
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    public store: List,
    public ds: DataService,
  ) { }

  async ngOnInit() {
    this.PROCESS = true;
    this.route.params.subscribe(async params => {
      const { id } = params;
      this.SELECTED_KEY = id;
      this.SELECTED_CURRICULUM = await this.store.fetchDoc(this.ds.curricularRef().doc(id));
      const { facultyKey } = this.SELECTED_CURRICULUM;
      this.FUCULTY_KEY = facultyKey;
      this.CURRICULAR = orderBy(await this.store.fetchList(this.ds.curricularRef(ref => ref.where("facultyKey", "==", facultyKey))), "name")
      this.COURSE_TYPES = await this.store.fetchList(this.ds.courseTypeRef(ref => ref.orderBy("order")))
      this.store.fetchGroupData(this.ds.curricularCourseRef(ref => ref.where("curriculumKey", "==", id)),"courseTypeKey","order")
      this.PROCESS = false;
    })
  }

  create(item: any) {
    let dialogRef = this.dialog.open(AddCurriculumCourseComponent, {
      data: { SELECTED_CURRICULUM: this.SELECTED_CURRICULUM, TYPE: item },
      panelClass: 'register-test-overlay-panel',
      width: '35vw',
      height: '100vh',
      disableClose: true,
      role: 'dialog',
    });
    dialogRef.updatePosition({ top: '0', right: '0', bottom: '0' });
    dialogRef.afterClosed().subscribe(result => { });
  }
}